import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Environment } from '@recovery/environments/env';

import { ENVIRONMENT } from '../../providers/environment.provider';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
  constructor(
    @Inject(ENVIRONMENT) private _env: Environment,
    private _cookieService: CookieService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const imageRegExp = new RegExp('^.*.(svg)$', 'g');
    if (imageRegExp.test(request.url)) {
      return next.handle(request);
    }
    return next.handle(request);
  }
}
